/**
 * Exhaustiveness check for discriminated unions (runtime should not reach).
 */
export const assertNever = (value: never, detail: string): never => {
  let serializedValue: string;

  try {
    serializedValue = JSON.stringify(value);
  } catch {
    serializedValue = String(value);
  }

  throw new Error(`${detail}: ${serializedValue}`);
};
